<template>
    <div>
        <Header />
        <Menu />

        <div class="container">
            <div class="gallery-holder" v-for="(imageAndCat, index) in allImagesAndCats" v-bind:key="index">
                <div class="gallery-title">
                    {{imageAndCat.title}}
                </div>
                <div class="gallery">
                    <div class="column" v-for="images in imageAndCat.arr" v-bind:key="images.id">
                        <hover-zoom v-for="img in images.arr" v-bind:key="img.id" :src="img.url" alt="" :canClick="true" />
                    </div>
                </div>
            </div>
        </div>

        <Footer />
    </div>
</template>

<script>

import utils from '../assets/js/utils'

    export default {
        data() {
            return {
                images: {},
                flatImageArr: [],
                allImages: [],
                allImagesAndCats: []
            }
        },
        mounted() {
            this.firebase = this.$store.getters.firebase;
            // this.importAll(require.context("../../public/images/portfolio/", true, /\.(png|jpe?g)$/))
            this.getFiles()
        },
        methods: {
            isObject(item) {
                return (item && typeof item === 'object' && !Array.isArray(item));
            },
           mergeDeep(target, ...sources) {
                if (!sources.length) return target;
                const source = sources.shift();

                if (this.isObject(target) && this.isObject(source)) {
                    for (const key in source) {
                    if (this.isObject(source[key])) {
                        if (!target[key]) Object.assign(target, { [key]: {} });
                        this.mergeDeep(target[key], source[key]);
                    } else {
                        Object.assign(target, { [key]: source[key] });
                    }
                    }
                }

                return this.mergeDeep(target, ...sources);
            },
            objThing(arr, end) {
                let obj = {}

                for(let i = 0; i < arr.length; i++) {
                    var removedKey = arr.shift();
                    if(arr.length) {
                        obj[removedKey] = this.objThing(arr, end)
                    } else {
                        obj[removedKey] = end;
                        this.flatImageArr.push({id: Math.floor(Math.random() * 1000000), url: end})
                    }
                }

                return obj;

            },

            importAll(r) {
                var imgs = {}
                r.keys().forEach(key => {
                    
                    const splitKey = key.slice(2, key.length).split('/');
                    
                    const htmlFriendlyPath = '/images/portfolio/' + key.slice(2, key.length).replace(' ', '%20')
                    const ot = this.objThing([...splitKey], htmlFriendlyPath)

                    imgs = this.mergeDeep(ot, imgs)

                })
                this.images = imgs

                this.allImages = utils.chunkArray(this.flatImageArr, 4)
            },

            getFiles() {
                const databaseRef = this.firebase.database().ref('/images');
                const categoryRef = this.firebase.database().ref('/categories');

                const thisVar = this

                const categoryArr = [];

                categoryRef.once('value', (snapshot) => {
                    for(const [key, cat] of Object.entries(snapshot.val())) {
                        categoryArr.push({
                            id: key,
                            ...cat
                        })
                    }

                    databaseRef.once('value', (snapshot) => {
                        const images = snapshot.val()
                        thisVar.allImages = typeof images === "object" && Object.keys(images).map((key) => {
                            return {
                                id: key,
                                ...images[key]
                            }
                        });

                        // thisVar.allImages = utils.chunkArray(thisVar.allImages, 4);

                        for(const cat of categoryArr) {
                            thisVar.allImagesAndCats.push({
                                title: cat.name,
                                arr: utils.chunkArray(thisVar.allImages.filter(v => v.category === cat.id), 4)
                            })
                        }

                    })
                })

                
            },
        }

    }
</script>

<style lang="scss" scoped>
.gallery-holder {
    margin-bottom: 20px;
}
</style>